<template>
  <b-dropdown size="sm" class="m-2" title="Mais ações" v-b-tooltip.hover>
    <template #button-content>
      <i class="fas fa-ellipsis-h mr-1"></i>
    </template>
    <b-dropdown-item-button @click="$emit('seeAccess')">
      <i class="fas fa-history mr-2"></i> Ver acessos
    </b-dropdown-item-button>
    <b-dropdown-item-button @click="$emit('accessLink')">
      <i class="fas fa-external-link-alt mr-2"></i> Link de acesso
    </b-dropdown-item-button>
  </b-dropdown>
</template>

<script>
export default {
  name: 'ImpersonateActions',
  emits: ['seeAccess', 'accessLink'],
};
</script>
